<template>
  <el-config-provider :locale="lang">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from 'element-plus'
import ja from 'element-plus/dist/locale/ja.min.mjs'
import useSettingsStore from '@/store/modules/settings'
import { handleThemeStyle } from '@/utils/theme'

import useStatusCompStore from '@/store/modules/statusComp.js';

const lang = ref(ja)
onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
